import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Link, useLocation } from "react-router-dom";
import * as TablerIcons from "@tabler/icons-react";
import { IconAlertTriangle } from "@tabler/icons-react";
import { API_ENDPOINTS } from "../api/endpoints";

const NavbarBottom = () => {
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const userName = Cookies.get("userName");

  useEffect(() => {
    if (!userName) return;

    const fetchMenus = async () => {
      setLoading(true);
      const urlMenus = API_ENDPOINTS.interna.get_user_menus(userName);

      try {
        const res = await fetch(urlMenus);
        const data = await res.json();
        setMenus(data);
      } catch (err) {
        console.error("Error cargando menús:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMenus();
  }, [userName]);

  const buildMenuTree = () => {
    const map = {};
    const tree = [];

    menus.forEach((menu) => {
      menu.children = [];
      map[menu.id] = menu;
    });

    menus.forEach((menu) => {
      if (menu.parent_id) {
        map[menu.parent_id]?.children.push(menu);
      } else {
        tree.push(menu);
      }
    });

    return tree;
  };

  const menuTree = buildMenuTree();

  const renderIcon = (iconName) => {
    if (!iconName) return null;
    const IconComponent = TablerIcons[iconName] || IconAlertTriangle;
    return <IconComponent size={20} className="me-1" />;
  };

  const isMenuActive = (menuItem) => {
    if (location.pathname === menuItem.url) return true;
    if (menuItem.children) {
      return menuItem.children.some(isMenuActive);
    }
    return false;
  };

  const renderMenuItems = (items, level = 1) => {
    return items.map((item) => {
      const isActive = location.pathname === item.url;
      const isActiveDropdown = isMenuActive(item);

      const handleDropdownClose = (e) => {
        const dropdowns = document.querySelectorAll(".dropdown-menu.show");
        dropdowns.forEach((dropdown) => {
          dropdown.classList.remove("show");
        });

        const parent = e.target.closest(".dropdown");
        if (parent) {
          parent.classList.remove("show");
        }

        const toggle = parent?.querySelector(".dropdown-toggle");
        if (toggle) {
          toggle.setAttribute("aria-expanded", "false");
        }
      };

      if (item.children && item.children.length > 0) {
        const dropdownClass = level === 1 ? "nav-item dropdown" : "dropend";
        const linkClass = level === 1 ? "nav-link dropdown-toggle" : "dropdown-item dropdown-toggle";

        return (
          <li key={item.id} className={`${dropdownClass}${isActiveDropdown ? " active" : ""}`}>
            <a href="#!" className={`${linkClass}${isActiveDropdown ? " active" : ""}`} data-bs-toggle="dropdown" data-bs-auto-close="outside" role="button" aria-expanded="false">
              {level === 1 && <span className="nav-link-icon d-md-none d-lg-inline-block">{renderIcon(item.icono)}</span>}
              <span className="nav-link-title">{item.title}</span>
            </a>
            <div className="dropdown-menu">
              <ul className="list-unstyled mb-0">{renderMenuItems(item.children, level + 1)}</ul>
            </div>
          </li>
        );
      } else {
        return (
          <li key={item.id} className={level === 1 ? `nav-item${isActive ? " active" : ""}` : ""}>
            <Link className={level === 1 ? `nav-link${isActive ? " active" : ""}` : "dropdown-item"} to={item.url} onClick={handleDropdownClose}>
              {level === 1 && <span className="nav-link-icon d-md-none d-lg-inline-block">{renderIcon(item.icono)}</span>}
              <span className="nav-link-title">{item.title}</span>
            </Link>
          </li>
        );
      }
    });
  };

  return (
    <header className="navbar-expand-md">
      <div className="collapse navbar-collapse" id="navbar-menu">
        <div className="navbar">
          <div className="container-xl">
            <ul className="navbar-nav">
              {loading ? (
                <li className="nav-item">
                  <span className="nav-link">
                    <i className="spinner-border spinner-border-sm me-2" role="status" /> Cargando menú...
                  </span>
                </li>
              ) : (
                renderMenuItems(menuTree, 1)
              )}
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

export default NavbarBottom;
